import React, { useEffect, useState } from "react";
import { Button, notification, Result, message, Row, Col, Form, Input } from "antd";
import { CheckOutlined } from '@ant-design/icons';
import { useHistory } from "react-router-dom";
import Screen from '../util/Extensions/Screens'
import RequestHandler from "../util/RequestHandler";

const NewPassword = (props) => {
  const history = useHistory();
  const [isHavePsrGuid, setIsHavePsrGuid] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    RequestHandler.get(`/Auth/IsHavePsrGuid?PsrGuid=${props.match.params.psrGuid}`).then(response => {
      if (response.success) {
        setIsHavePsrGuid(true);
      }
    });
  }, []);

  const onFinishFailed = () => setLoading(false);

  const onFinish = values => {
    const hide = message.loading('İşleminiz gerçekleştiriliyor..', 0);
    if (values.password !== values.confirm) {
      NotSamePasswordWarning('error')
      setLoading(false)
      hide()
    } else {
      RequestHandler.post(`/Auth/NewPassword`, {
        PsrGuid: props.match.params.psrGuid,
        Password: values.password
      }, false, { rawResponse: true }).then(res => {
        if (res.status == 200) {
          openNotificationWithIcon('success');
          hide();

          setTimeout(function () {
            history.push('/signin');
          }.bind(this), 2000);
        }else{
        setLoading(false)
        }
      });
    }
  };

  const openNotificationWithIcon = type => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Şifre güncelleme işlemi başarı ile gerçekleşti.',
      duration: 2,
    });
  };
  
  const NotSamePasswordWarning = type => {
    notification[type]({
      message: 'HATA',
      description:
        'Şifreler aynı değil.',
      duration: 2,
    });
  };

  return (
    isHavePsrGuid === true ?
      <div className="gx-login-container"  >
        <div className="gx-login-content">

          <div className="gx-login-header">
            {
              Screen.screen === 0 ?
                <img src={require("assets/images/tahsilat-glass-logo-png.png")} alt="tahsilite" title="tahsilite" style={{ width: '40%' }} />
                :
                (
                  Screen.screen === 1 ?
                    <img src={require("assets/images/imzaPosLogo.png")} alt="tahsilite" title="tahsilite" style={{ width: '40%' }} />
                    :
                    <img src={require("assets/images/logoBakiyem.png")} alt="tahsilite" title="bakiyem" style={{ width: '40%' }} />
                )

            }

          </div>
          <div className="gx-mb-4">
            <h3>Şifre Oluştur</h3>
            <p>Hesabınızın şifresini giriniz.</p>
          </div>

          <Form
            initialValues={{ remember: true }}
            name="basic"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            className="gx-signin-form gx-form-row0">

            <Form.Item rules={[{ required: true, message: 'Lütfen şifrenizi giriniz.' }]} name="password">
              <Input className='gx-input-lineheight' type="password" placeholder="Şifrenizi Giriniz" autoComplete={false} onKeyDown={(evt) => evt.keyCode === 32 && evt.preventDefault()} />
            </Form.Item>

            <Form.Item rules={[{ required: true, message: 'Lütfen şifrenizi giriniz.' }]} name="confirm">
              <Input className='gx-input-lineheight' placeholder="Şifrenizi Tekrar Giriniz" autoComplete={false} type="password" onKeyDown={(evt) => evt.keyCode === 32 && evt.preventDefault()} />
            </Form.Item>
            <Row>
              <Col span={12}>
                <Form.Item>
                  <Button type="primary" icon={<CheckOutlined />} htmlType="submit" onClick={() => setLoading(true)} loading={loading}>
                    Oluştur
                  </Button>
                </Form.Item>
              </Col>
              <Col span={12}>
                <a href="/signin">
                  Giriş Sayfasına Dön
                </a>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
      :
      <div>
        <Result
          status="404"
          title="404"
          subTitle="Üzgünüm, böyle bir kullanıcı bulamadım."
          extra={<Button type="primary" href='/signin'>Giriş Sayfasına Dön</Button>}
        />
      </div>
  );
};

export default NewPassword;
